import React, {useState} from 'react';

import Skeleton, {SkeletonProps} from '@mui/material/Skeleton';

import {ContainerStyled, StyledImage} from './styles';

export interface ImageLoaderProps {
  image: {
    src: string;
    alt?: string;
    layout?: string;
    objectFit?: string;
    width?: number | string;
    height?: number | string;
    sizes?: string;
    quality?: number;
    objectPosition?: string;
  };
  skelton: SkeletonProps;
  className?: string;
  removeImageSkeleton?: boolean;
}
export const ImageLoader: React.FC<ImageLoaderProps> = ({image, skelton, className, removeImageSkeleton = false}) => {
  const [hasPlaceholder, setHasPlaceholder] = useState(true);
  const [hasError, setHasError] = useState(false);
  return (
    <ContainerStyled className={className || ''}>
      {!hasError && hasPlaceholder && !removeImageSkeleton && <Skeleton {...skelton} />}
      <StyledImage
        src={image.src}
        alt="Static map"
        onLoad={() => {
          setHasPlaceholder(false);
        }}
        onError={() => {
          setHasError(true);
        }}
      />
    </ContainerStyled>
  );
};

export default ImageLoader;
